import * as React from "react";
import { useEffect, useRef } from 'react';

const VideoPlayer = ({ id, publicId, width, height, ...props }) => {
  const videoRef = useRef();
  const cloudinaryRef = useRef();
  const playerRef = useRef();

  // Store the Cloudinary window instance to a ref when the page renders

  useEffect(() => {
    if ( cloudinaryRef.current ) return;

    cloudinaryRef.current = window.cloudinary;

    const playerConfig = {
      cloud_name: process.env.REACT_APP_CLOUDINARY_CLOUD_NAME,
      secure: true,
      crossOrigin: 'anonymous'
    };

    // Add width and height to player config if provided
    if (width) playerConfig.width = width;
    if (height) playerConfig.height = height;

    playerRef.current = cloudinaryRef.current.videoPlayer(videoRef.current, playerConfig);
  }, [width, height]);

  return (
    <div style={{ width: width ? `${width}px` : '100%', height: height ? `${height}px` : 'auto' }}>
      <video
        ref={videoRef}
        id={id}
        className="cld-video-player"
        controls
        autoPlay
        crossOrigin="anonymous"
        data-cld-public-id={publicId}
        width={width}
        height={height}
        {...props}
      />
    </div>
  )
}

export default VideoPlayer;
